module.exports = [
  {
  	color: "#9C27B0",
    points: 3,
    tiles: [[false, true, false],
            [false, true, false],
            [false, true, false]]
  },

  {
  	color: "#9C27B0",
    points: 3,
    tiles: [[false, false, false],
            [true, true, true],
            [false, false, false]]
  },
  {
  	color: "#9C27B0",
    points: 3,
    tiles: [[false, true, false],
            [false, true, false],
            [false, true, false]]
  },

  {
  	color: "#9C27B0",
    points: 3,
    tiles: [[false, false, false],
            [true, true, true],
            [false, false, false]]
  },
  {
  	color: "#9C27B0",
    points: 3,
    tiles: [[false, true, false],
            [false, true, false],
            [false, true, false]]
  },

  {
  	color: "#9C27B0",
    points: 3,
    tiles: [[false, false, false],
            [true, true, true],
            [false, false, false]]
  },
  {
  	color: "#FF5722",
    points: 2,
    tiles: [[false, true, false],
            [false, true, false],
            [false, false, false]]
  },

  {
  	color: "#FF5722",
    points: 2,
    tiles: [[false, false, false],
            [true, true, false],
            [false, false, false]]
  },


  {
  	color: "#D32F2F",
    points: 5,
    tiles: [[true, true, true],
            [true, false, false],
            [true, false, false]]
  },

  {
  	color: "#D32F2F",
    points: 5,
    tiles: [[false, false, true],
            [false, false, true],
            [true, true, true]]
  },
  {
  	color: "#D32F2F",
    points: 5,
    tiles: [[true, true, true],
            [false, false, true],
            [false, false, true]]
  },

  {
  	color: "#D32F2F",
    points: 5,
    tiles: [[true, false, false],
            [true, false, false],
            [true, true, true]]
  },
  {
  	color: "#D32F2F",
    points: 5,
    tiles: [[true, true, true],
            [true, false, false],
            [true, false, false]]
  },

  {
  	color: "#D32F2F",
    points: 5,
    tiles: [[false, false, true],
            [false, false, true],
            [true, true, true]]
  },

  {
  	color: "#009688",
    points: 9,
    tiles: [[true, true, true],
            [true, true, true],
            [true, true, true],]
  },
  {
  	color: "#00C853",
    points: 1,
    tiles: [[false, false, false],
            [false, true, false],
            [false, false, false],]
  },
  {
  	color: "#009688",
    points: 9,
    tiles: [[true, true, true],
            [true, true, true],
            [true, true, true],]
  },

  {
  	color: "#EC407A",
    points: 3,
    tiles: [[false, true, true],
            [false, false, true],
            [false, false, false],]
  },
  {
  	color: "#EC407A",
    points: 3,
    tiles: [[false, false, false],
            [true, false, false],
            [true, true, false],]
  },
  {
  	color: "#EC407A",
    points: 3,
    tiles: [[true, true, false],
            [true, false, false],
            [false, false, false],]
  },
  {
  	color: "#EC407A",
    points: 3,
    tiles: [[false, false, false],
            [false, false, true],
            [false, true, true],]
  },
  {
  	color: "#FFC107",
    points: 4,
    tiles: [[false, true, true],
            [false, true, true],
            [false, false, false],]
  },
  {
  	color: "#FFC107",
    points: 4,
    tiles: [[false, true, true],
            [false, true, true],
            [false, false, false],]
  }
]



/*****************
 ** WEBPACK FOOTER
 ** ./lib/piecesArr.js
 ** module id = 6
 ** module chunks = 0
 **/